export const SEND_CALLBACKS = "SEND_CALLBACKS";
export const SEND_CALLBACKS_SUCCESS = "SEND_CALLBACKS_SUCCESS";
export const SEND_CALLBACKS_ERROR = "SEND_CALLBACKS_ERROR";
